import { Component, input, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '../../atoms/skeleton/skeleton.component';

export interface DataDisplayItem {
  label: string;
  value?: string[];
  template?: TemplateRef<any>;
}

@Component({
  selector: 'htx-data-display',
  standalone: true,
  imports: [CommonModule, SkeletonComponent],
  templateUrl: './data-display.component.html',
  styleUrls: ['./data-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataDisplayComponent {
  title = input<string>('');
  icon = input<string>('');
  data = input<DataDisplayItem[]>([]);
  loading = input<boolean>(false);
}
